/* DOMAINS */
export const GET_DOMAINS = "GET_DOMAINS"
export const GET_DOMAINS_SUCCESS = "GET_DOMAINS_SUCCESS"
export const GET_DOMAINS_FAIL = "GET_DOMAINS_FAIL"

export const GET_CREDENTIALS = "GET_CREDENTIALS"
export const GET_CREDENTIALS_SUCCESS = "GET_CREDENTIALS_SUCCESS"
export const GET_CREDENTIALS_FAIL = "GET_CREDENTIALS_FAIL"

export const ADD_DOMAIN = "ADD_DOMAIN"
export const ADD_DOMAIN_SUCCESS = "ADD_DOMAIN_SUCCESS"
export const ADD_DOMAIN_FAIL = "ADD_DOMAIN_FAIL"

export const UPDATE_DOMAIN = "UPDATE_DOMAIN"
export const UPDATE_DOMAIN_SUCCESS = "UPDATE_DOMAIN_SUCCESS"
export const UPDATE_DOMAIN_FAIL = "UPDATE_DOMAIN_FAIL"

export const DELETE_DOMAIN = "DELETE_DOMAIN"
export const DELETE_DOMAIN_SUCCESS = "DELETE_DOMAIN_SUCCESS"
export const DELETE_DOMAIN_FAIL = "DELETE_DOMAIN_FAIL"

/* SUBSCRIPTIONS */
export const GET_SUBS = "GET_SUBS"
export const GET_SUBS_SUCCESS = "GET_SUBS_SUCCESS"
export const GET_SUBS_FAIL = "GET_SUBS_FAIL"

export const ADD_SUB = "ADD_SUB"
export const ADD_SUB_SUCCESS = "ADD_SUB_SUCCESS"
export const ADD_SUB_FAIL = "ADD_SUB_FAIL"

export const UPDATE_SUB = "UPDATE_SUB"
export const UPDATE_SUB_SUCCESS = "UPDATE_SUB_SUCCESS"
export const UPDATE_SUB_FAIL = "UPDATE_SUB_FAIL"

export const DELETE_SUB = "DELETE_SUB"
export const DELETE_SUB_SUCCESS = "DELETE_SUB_SUCCESS"
export const DELETE_SUB_FAIL = "DELETE_SUB_FAIL"

export const SHOW_LOADING = "SHOW_LOADING"
export const HIDE_LOADING = "HIDE_LOADING"